import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

// Lets elements outside the sidebar (e.g. Home tout, deep links) open the nav notifications popover,
// optionally straight onto the settings pane. `view` is 'list' or 'settings'.
export const useNotificationsPopoverStore = defineStore('notificationsPopover', () => {
    const isOpen = ref(false)
    const view = ref('list')

    function open(nextView = 'list') {
        view.value = nextView
        isOpen.value = true
    }

    function openSettings() {
        open('settings')
    }

    // A later click on the bell should land on the list, not on whatever view a deep link requested.
    watch(
        isOpen,
        (open) => {
            if (!open) view.value = 'list'
        },
        { flush: 'sync' }
    )

    return { isOpen, view, open, openSettings }
})
